module.exports = __webpack_public_path__ + "img/HomeHeader.28de8492.jpg";